<template>
  <v-app>
    <v-main>
      <v-container class="fill-height">
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <v-col
            cols="4"
            class="text-center"
          >
            <img
              :src="require('@/assets/bizmates.svg')"
              alt="Bizmates"
              class="mb-4"
            >
            <h3 class="display-1">
              Sorry, this browser is currently not supported by this website. &#9785;<span />
            </h3>
            <div class="body-1 my-6 text-left">
              <p>It seems like you are using a browser that does not support this application.</p>
              <p>We recommend using any of the following browsers:</p>
              <v-list
                style="background:none"
                disabled
              >
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, i) in items"
                    :key="i"
                    class="pa-0"
                  >
                    <template #prepend>
                      <v-icon :icon="item.icon" />
                    </template>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data () {
    return {
      items: [
        {
          text: 'Google Chrome 70 and above',
          icon: 'mdi-google-chrome'
        },
        {
          text: 'Mozilla FireFox 67 and above',
          icon: 'mdi-firefox'
        },
        {
          text: 'Internet Explorer Edge',
          icon: 'mdi-edge'
        },
        {
          text: 'Safari 11 and above',
          icon: 'mdi-apple-safari'
        }
      ]
    }
  }
}
</script>
